import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aa5731c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-bot" }
const _hoisted_2 = { class: "chat-iconwidget" }
const _hoisted_3 = { class: "widget-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please ask questions regarding the Dart rulse", -1))
const _hoisted_5 = {
  class: "chat-container",
  id: "chat-container"
}
const _hoisted_6 = { class: "chat-a" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id"]
const _hoisted_10 = {
  key: 0,
  class: "loader",
  id: "chat-loader"
}
const _hoisted_11 = { class: "widget-bottom" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_it_divider = _resolveComponent("it-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["widget-body", !_ctx.isInitialDone ? '' : _ctx.widget ? 'new__animation' : 'reverse__animation'])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("button", {
              class: "mobile-close-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.widgetManageFunction && _ctx.widgetManageFunction(...args)))
            }, [
              (_ctx.widget)
                ? (_openBlock(), _createBlock(_component_va_icon, {
                    key: 0,
                    name: "close",
                    size: "large",
                    color: "#ffffff"
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.welcomeMessage), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqQuestions, (faqQuestion, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "faq-questions",
                onClick: ($event: any) => (_ctx.setFaqQuestion(index))
              }, _toDisplayString(faqQuestion), 9, _hoisted_7))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chats, (chate, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (chate.q)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "chat-q",
                      id: `que-${index}`
                    }, _toDisplayString(chate.q), 9, _hoisted_8))
                  : _createCommentVNode("", true),
                (chate.a)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "chat-a",
                      id: `ans-${index}`
                    }, _toDisplayString(chate.a), 9, _hoisted_9))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.chatLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                    return _createElementVNode("span", { key: i })
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_it_divider, { style: {"margin":"12px 0 !important"} }),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userQuestion) = $event)),
              placeholder: "Enter your query..",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (!_ctx.isUserQuestionEmpty() && _ctx.sendTheQuestionToAssistant()), ["enter"])),
              disabled: _ctx.chatLoading
            }, null, 40, _hoisted_12), [
              [_vModelText, _ctx.userQuestion]
            ]),
            _createElementVNode("button", {
              class: "send-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendTheQuestionToAssistant())),
              disabled: _ctx.isUserQuestionEmpty() || _ctx.chatLoading
            }, [
              _createVNode(_component_va_icon, { name: "send" })
            ], 8, _hoisted_13)
          ])
        ], 2),
        _createElementVNode("button", {
          class: "widget-button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.widgetManageFunction && _ctx.widgetManageFunction(...args)))
        }, [
          (!_ctx.widget)
            ? (_openBlock(), _createBlock(_component_va_icon, {
                key: 0,
                name: "forum",
                size: "large",
                color: "#ffffff"
              }))
            : _createCommentVNode("", true),
          (_ctx.widget)
            ? (_openBlock(), _createBlock(_component_va_icon, {
                key: 1,
                name: "close",
                size: "large",
                color: "#ffffff"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}